import React from 'react'

import ErrorBoundary from "../../../../error-boundary"

type Props = {
    title               : string
    isOpen?             : boolean
    description?        : string
    children?           : any
    className?          : string
    isFoldable?         : boolean   // experimental not in use ?
}

export default class RightPanelFoldableSection extends React.Component<Props,any> {

    constructor(props:Props) {
        super(props);

        this.state = {
            isOpen      : _.get(props,'isOpen', true),
            isFoldable  : _.get(props,'isFoldable', true)
        }
    }

    toggleIsOpen= () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    render() {
        const classes = Classes('foldable-section', this.props.className)

        const foldBtnClasses = Classes('fold-btn', {
            'i5-big-angle-right'   : !this.state.isOpen,
            'i5-big-angle-down'    : this.state.isOpen
        })

        return (
            <ErrorBoundary>
                <div className={classes}>
                    <div className="section-header" onClick={this.toggleIsOpen}>
                        <div className="line-through"></div>
                        {this.state.isFoldable &&
                            <div className={foldBtnClasses}></div>
                        }
                        <div className="title">{this.props.title}</div>
                    </div>

                    {!this.state.isOpen && this.props.description &&
                        <div className="section-description-closed ui5-txt-not-important-small" onClick={this.toggleIsOpen}>
                            {this.props.description}
                        </div>
                    }

                    {this.state.isOpen &&
                        <div className="section-content">
                            {this.props.children}
                        </div>
                    }
                </div>
            </ErrorBoundary>
        )
    }
}